import { useEffect, useLayoutEffect, useState } from 'react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { Dispatch, RootState } from '@/store'
import { ImageResponsive } from '@/types/common'

export const useAppDispatch = () => useDispatch<Dispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const useBrowserLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : () => {}

interface ResponsiveImageProps {
  images: ImageResponsive
}

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<'mobile' | 'tablet' | 'desktop'>('desktop')

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setScreenSize('mobile')
      } else if (window.innerWidth < 1024) {
        setScreenSize('tablet')
      } else {
        setScreenSize('desktop')
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return screenSize
}

export const useResponsiveImage = (images: ResponsiveImageProps['images']) => {
  const screenSize = useScreenSize()
  switch (screenSize) {
    case 'mobile':
      return images.mobile.url
    case 'tablet':
      return images.tablet.url
    case 'desktop':
    default:
      return images.desktop.url
  }
}
